import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import reportWebVitals from "./reportWebVitals.ts";
import { AuthProvider } from "./context/AuthContext.tsx";
import { BrowserRouter as Router } from "react-router-dom";
import "./components/ChessLoginScreen.css"; // Import stylů pro přihlašovací obrazovku
import AnalyticsTracker from "./components/AnalyticsTracker.tsx";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Router>
        <AnalyticsTracker />
        <App />
      </Router>
    </AuthProvider>
  </React.StrictMode>,
);

reportWebVitals();
